const calcularPx = (valor) => {
  return (valor * 1536) / 1920 + "px";
};

export default calcularPx;
